import { SKOS } from "./vocabulary.js";
export var Cardinality;
(function (Cardinality) {
    Cardinality["ZeroToZero"] = "0-0";
    Cardinality["ZeroToOne"] = "0-1";
    Cardinality["ZeroToMany"] = "0-n";
    Cardinality["OneToZero"] = "1-0";
    Cardinality["OneToOne"] = "1-1";
    Cardinality["OneToMany"] = "1-n";
    Cardinality["ManyToZero"] = "n-0";
    Cardinality["ManyToOne"] = "n-1";
    Cardinality["ManyToMany"] = "n-n";
})(Cardinality || (Cardinality = {}));
export const DSV_REUSE_LABEL = SKOS.prefLabel.id;
export const DSV_REUSE_DESCRIPTION = SKOS.definition.id;
export const DSV_REUSE_USAGE_NOTE = SKOS.scopeNote.id;
export var ClassRole;
(function (ClassRole) {
    ClassRole[ClassRole["undefined"] = 0] = "undefined";
    ClassRole[ClassRole["main"] = 1] = "main";
    ClassRole[ClassRole["supportive"] = 2] = "supportive";
})(ClassRole || (ClassRole = {}));
export const ClassProfileType = "class-profile";
export function isClassProfile(profile) {
    return profile.type.includes(ClassProfileType);
}
export var RequirementLevel;
(function (RequirementLevel) {
    RequirementLevel[RequirementLevel["undefined"] = 0] = "undefined";
    RequirementLevel[RequirementLevel["mandatory"] = 1] = "mandatory";
    RequirementLevel[RequirementLevel["optional"] = 2] = "optional";
    RequirementLevel[RequirementLevel["recommended"] = 3] = "recommended";
})(RequirementLevel || (RequirementLevel = {}));
export function isPropertyProfile(profile) {
    return profile.type.includes(ObjectPropertyProfileType)
        || profile.type.includes(DatatypePropertyProfileType);
}
export const ObjectPropertyProfileType = "object-property-profile";
export function isObjectPropertyProfile(profile) {
    return (profile.type ?? []).includes(ObjectPropertyProfileType);
}
export const DatatypePropertyProfileType = "datatype-property-profile";
export function isDatatypePropertyProfile(profile) {
    return (profile.type ?? []).includes(DatatypePropertyProfileType);
}
//# sourceMappingURL=dsv-model.js.map